import { redLightest, white } from '@bufferapp/ui/style/colors';
import styled from 'styled-components';

export const VoidText = styled.span<{ $isPastCharacterLimit?: boolean }>`
  background-color: ${(p) => (p.$isPastCharacterLimit ? redLightest : white)};
`;
